module.exports = __webpack_public_path__ + "static/img/zhijiao.1e2b6e65.png";